import { View } from 'react-native';

import { Badge } from '@/components/ui/Badge';
import { cn } from '@/components/ui/cn';
import { Text } from '@/components/ui/Text';

/** Read-only template guidance shown during a run ("Ref" tag). */
export function ReferenceNote({
  text,
  flush,
  className,
}: {
  text: string;
  /** Drop the default `ml-9` inset — the caller already positions it (sealed
   *  timeline content column). */
  flush?: boolean;
  className?: string;
}) {
  return (
    <View
      className={cn(
        'flex-row gap-2 rounded-lg bg-well px-3 py-2',
        !flush && 'ml-9',
        className,
      )}
    >
      <Badge label="Ref" tone="neutral" />
      <Text variant="caption" className="flex-1 text-foreground-secondary">
        {text}
      </Text>
    </View>
  );
}
